export const compareArrayOfObjects = (arr1, arr2) => {
  return (
    arr1.length === arr2.length &&
    arr1.every((el_1) =>
      arr2.some((el_2) =>
        Object.keys(el_1).every((key) => el_1[key] === el_2[key])
      )
    )
  );
};